import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { apiClient } from "@/context/AuthContext";
import { useAuth } from "@/context/AuthContext";
import { Flame, AlertTriangle } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login", { replace: true }); return; }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await apiClient.post("/auth/session", { session_id: sessionId });
        await refresh();
        navigate("/home", { replace: true, state: { user: data.user } });
      } catch (err) {
        setError(err?.response?.data?.detail || "Google oturumu doğrulanamadı");
        setTimeout(() => navigate("/login", { replace: true }), 2200);
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="auth-splash" data-testid="auth-callback">
      {error ? <><AlertTriangle size={22}/> <span>{error}</span></> : <><Flame size={24}/> <span>Giriş doğrulanıyor…</span></>}
    </div>
  );
}
